import BIRMINGHAM from 'url:./2026.10 - oleshky - birmingham.jpeg'
import EDINBURGH from 'url:./2026.10 - oleshky - edinburgh.png'
import VIENNA from 'url:./2026.10 - oleshky - vienna.png'
import MUNICH from 'url:./2026.10 - oleshky - Munich.jpg'
import LONDON from 'url:./2026.10 - oleshky - London.jpg'
import LONDON_KARTONKY from 'url:./2026 - oleshky - london kartonki.jpg'
import LONDON_OCT from 'url:./2026.10 - oleshky - london2.jpg'
import BUDAPEST from 'url:./2026.10 - oleshky - budapest.jpeg'
import HAMBURG from 'url:./2026.10 - oleshky - hamburg.jpeg'
import KIEL from 'url:./2026.10 - oleshky - kiel.jpg'
import KIEL_2 from 'url:./2026.10 - oleshky - kiel2.jpg'
import MUNICH_2 from 'url:./2026.10 - oleshky - munich1.jpg'
import MANCHESTER from 'url:./2026.10 - oleshky - manchester.jpg'
import PARIS from 'url:./2026.10 - oleshky - paris.jpeg'
import LYON from 'url:./2026.10 - oleshky - lyons.jpg'
import DUBLIN from 'url:./2026.10 - oleshky - dublin.jpg'
import DUBLIN_OCT11 from 'url:./2026.10 - oleshky - dublin2.jpg'
import BRUSSELS from 'url:./2026.10 - oleshky - brussels.jpg'
import GDANSK from 'url:./2026.10 - oleshky - gdansk.jpg'
import NANTES from 'url:./2026.10 - oleshky - nantes.jpg'
import OTTAWA from 'url:./2026.10 - oleshky - Ottawa.jpeg'
import CHICAGO from 'url:./2026.10 - oleshky - chicago.jpeg'
import DRESDEN from 'url:./2026.10 - oleshky - dresden.jpg'
import MALAGA from 'url:./2026.10 - oleshky - malaga.jpg'
import CHICAGO_UA_DAUGHTERS from 'url:./2026.10 - oleshky - chicago - ua daughters.jpg'
import STOP_DRONE_SIEGE from 'url:./Stop Russian Drone Siege - Zarina Zabrisky.jpeg'
import NO_ROAD_OUT from 'url:./Oleshky, no road out - Oleksandra Kniga.jpg'
import OLESHKY from 'url:./OLESHKY - Stas Kolotov.jpg'
import OLESHKY_2 from 'url:./OLESHKY 2 - Stas Kolotov.jpg'
import OLESHKY_STOP_DRONE_SIEGE from 'url:./OLESHKY-stop-drone-siege.jpg'
import HUMANITARIAN_CATASTROPHE from 'url:./Oleksiy Kustovsky - Oleshky. A humanitarian catastrophe under occupation.jpeg'

type Poster = { src: string; city: string; label?: string; author?: string; link?: string }

// Posters by named artists. Also shown, in their own order, in the Download graphics section (artPosters).
const stopDroneSiege: Poster = {
  src: STOP_DRONE_SIEGE,
  city: 'none',
  label: 'rallies.oleshky2026.posterStopSiege',
  author: 'Zarina Zabrisky',
}
const noRoadOut: Poster = {
  src: NO_ROAD_OUT,
  city: 'none',
  label: 'rallies.oleshky2026.posterNoRoadOut',
  author: 'Oleksandra Kniga',
}
const humanitarianCatastrophe: Poster = {
  src: HUMANITARIAN_CATASTROPHE,
  city: 'none',
  label: 'rallies.oleshky2026.posterHumanitarianCatastrophe',
  author: 'Oleksiy Kustovsky',
}
const oleshky: Poster = { src: OLESHKY, city: 'none', author: 'Stas Kolotov' }
const oleshky2: Poster = { src: OLESHKY_2, city: 'none', author: 'Stas Kolotov' }
const oleshkyStopDroneSiege: Poster = {
  src: OLESHKY_STOP_DRONE_SIEGE,
  city: 'none',
  author: 'Stas Kolotov',
}

// Posters for the October 2026 rally (/oleshky). Import each poster here and add it to the list.
// Posters not tied to a city use city: 'none' and a `label` translation key as the overlay text.
// Posters by a named artist (e.g. in the file name) must set `author`; it is always shown in the overlay,
// and they must also be added to artPosters below.
export const oct2026Posters: Poster[] = [
  { src: DUBLIN, city: 'dublin' },
  noRoadOut,
  { src: MUNICH_2, city: 'munich' },
  {
    src: LONDON_OCT,
    city: 'londonOct1',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  { src: CHICAGO, city: 'chicago' },
  { src: BUDAPEST, city: 'budapest' },
  { src: KIEL_2, city: 'kiel' },
  { src: MALAGA, city: 'malaga' },
  humanitarianCatastrophe,
  { src: MUNICH, city: 'munich' },
  {
    src: LONDON_KARTONKY,
    city: 'londonSep29',
    link: 'https://www.instagram.com/p/Ddz2YmYMQ8b/',
  },
  { src: BRUSSELS, city: 'brussels' },
  { src: EDINBURGH, city: 'edinburgh' },
  oleshkyStopDroneSiege,
  { src: MANCHESTER, city: 'manchester' },
  { src: KIEL, city: 'kiel' },
  {
    src: DUBLIN_OCT11,
    city: 'dublinOct11',
    link: 'https://www.instagram.com/p/DePMFG1uVvE/',
  },
  { src: GDANSK, city: 'gdansk' },
  { src: OTTAWA, city: 'ottawa' },
  oleshky2,
  { src: DRESDEN, city: 'dresden' },
  { src: VIENNA, city: 'vienna' },
  {
    src: CHICAGO_UA_DAUGHTERS,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  oleshky,
  { src: HAMBURG, city: 'hamburg' },
  { src: NANTES, city: 'nantes' },
  { src: PARIS, city: 'paris' },
  stopDroneSiege,
  { src: BIRMINGHAM, city: 'birmingham' },
  { src: LYON, city: 'lyon' },
  { src: LONDON, city: 'london' },
]

// Download graphics section on the occupied (left bank) page
export const artPosters: Poster[] = [
  oleshky,
  noRoadOut,
  oleshkyStopDroneSiege,
  stopDroneSiege,
  oleshky2,
]
